import { getFileNameFromResponse } from '$core/helpers/get-filename-from-header';
import { saveBlob } from '$core/helpers/save-blob';
import { Pagination } from '$core/models/pagination';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import {
  CreateInvoiceBody,
  DownloadInvoiceParams,
  Invoice,
} from '../models/invoice';
import {
  InvoicesQueryParams,
  RemoveAddressOrInvoicesBody,
} from '$modules/personal/modules/batch/features/addresses/models/batch-recipient';

@Injectable({ providedIn: 'root' })
export class InvoicesService {
  protected apiRoute = '/batch-mailing/receipt';
  protected apiVersion = '/v1';

  constructor(private readonly _http: HttpClient) {}

  public getInvoices(
    query: InvoicesQueryParams
  ): Observable<Pagination<Invoice>> {
    let params = new HttpParams();
    if (query) {
      Object.entries(query).forEach(([key, value]) => {
        if (value) {
          params = params.set(key, value);
        }
      });
    }

    return this._http
      .get<Pagination<Invoice>>(`${this.apiVersion}${this.apiRoute}`, {
        params,
      })
      .pipe(
        map((res) => {
          res.data.map((el) => (el = new Invoice(el)));
          return res;
        })
      );
  }

  public downloadInvoice(
    id: number,
    query: DownloadInvoiceParams
  ): Observable<HttpResponse<Blob>> {
    const url = `${this.apiVersion}${this.apiRoute}/${id}/download`;

    let params = new HttpParams();
    params = params.set('type', query.type);

    return this._http
      .get(url, { observe: 'response', responseType: 'blob', params })
      .pipe(
        tap((res) => {
          const fileName = getFileNameFromResponse(res, 'receipt.pdf');

          saveBlob(res.body, fileName);
          return res.body;
        })
      );
  }

  public print(id: number): Observable<Blob> {
    const url = `${this.apiVersion}${this.apiRoute}/${id}/download`;

    return this._http.get(url, { responseType: 'blob' }).pipe(
      tap((blob) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'blank';
        return blob;
      })
    );
  }

  public createInvoice(params: CreateInvoiceBody): Observable<Invoice> {
    return this._http
      .post<Invoice>(`${this.apiVersion}${this.apiRoute}`, params)
      .pipe(
        map((res) => {
          res = new Invoice(res);
          return res;
        })
      );
  }

  public removeInvoices(
    body: RemoveAddressOrInvoicesBody
  ): Observable<unknown> {
    return this._http.post(
      `${this.apiVersion}/batch-mailing/receipts-delete`,
      body
    );
  }
}
